import Vue from 'vue'
import { URL_LOTS } from '@/constants/urls.js'
import { LOT_POSITIONS_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [LOT_POSITIONS_MANAGEMENT.STATE.POSITIONS]: null,
  [LOT_POSITIONS_MANAGEMENT.STATE.CURRENT_POSITION]: null
}

const actions = {
  async [LOT_POSITIONS_MANAGEMENT.ACTIONS.GET_POSITIONS_LIST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/positions?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_POSITIONS_MANAGEMENT.MUTATIONS.GET_POSITIONS_LIST, resp.data)
  },
  async [LOT_POSITIONS_MANAGEMENT.ACTIONS.GET_POSITION_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/positions/${model.premiumType}/${model.positionId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_POSITIONS_MANAGEMENT.MUTATIONS.GET_POSITION_INFO, resp.data)
  },
  async [LOT_POSITIONS_MANAGEMENT.ACTIONS.CREATE_POSITION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/positions/${model.premiumType}`,
      model: model.position
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_POSITIONS_MANAGEMENT.ACTIONS.UPDATE_POSITION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/positions/${model.premiumType}/${model.positionId}`,
      model: model.position
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_POSITIONS_MANAGEMENT.ACTIONS.DELETE_POSITION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/positions/${model.positionId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_POSITIONS_MANAGEMENT.ACTIONS.CLEAR_POSITION_INFO] ({ commit }) {
    commit(LOT_POSITIONS_MANAGEMENT.MUTATIONS.CLEAR_POSITION_INFO)
  },
  async [LOT_POSITIONS_MANAGEMENT.ACTIONS.CLEAR_POSITIONS_LIST] ({ commit }) {
    commit(LOT_POSITIONS_MANAGEMENT.MUTATIONS.CLEAR_POSITIONS_LIST)
  }
}

const mutations = {
  [LOT_POSITIONS_MANAGEMENT.MUTATIONS.GET_POSITION_INFO] (state, position) {
    state[LOT_POSITIONS_MANAGEMENT.STATE.CURRENT_POSITION] = position
  },
  [LOT_POSITIONS_MANAGEMENT.MUTATIONS.GET_POSITIONS_LIST] (state, positions) {
    state[LOT_POSITIONS_MANAGEMENT.STATE.POSITIONS] = positions
  },
  [LOT_POSITIONS_MANAGEMENT.MUTATIONS.CLEAR_POSITION_INFO] (state) {
    state[LOT_POSITIONS_MANAGEMENT.STATE.CURRENT_POSITION] = null
  },
  [LOT_POSITIONS_MANAGEMENT.MUTATIONS.CLEAR_POSITIONS_LIST] (state) {
    state[LOT_POSITIONS_MANAGEMENT.STATE.POSITIONS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}

/*
import Vue from 'vue'
import { urlLots } from '../../../constants/urls'

const state = {
  positions: null,
  currentPosition: null
}

const actions = {
  async getPositionsList ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${urlLots}/${model.lotId}/positions?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch('getAxiosRequest', model, { root: true })
    commit('errorClear', null, { root: true })
    commit('getPositionsList', resp.data)
  },
  async getPositionInfo ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${urlLots}/${model.lotId}/positions/${model.premiumType}/${model.positionId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch('getAxiosRequest', model, { root: true })
    commit('errorClear', null, { root: true })
    commit('getPositionInfo', resp.data)
  },
  async createPosition ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${urlLots}/${model.lotId}/positions/${model.premiumType}`,
      model: model.position
    }
    await dispatch('postAxiosRequest', model, { root: true })
    commit('errorClear', null, { root: true })
  },
  async updatePosition ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${urlLots}/${model.lotId}/positions/${model.premiumType}/${model.positionId}`,
      model: model.position
    }
    await dispatch('putAxiosRequest', model, { root: true })
    commit('errorClear', null, { root: true })
  },
  async deletePosition ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${urlLots}/${model.lotId}/positions/${model.positionId}`
    }
    await dispatch('deleteAxiosRequest', model, { root: true })
    commit('errorClear', null, { root: true })
  },
  async clearPositionInfo ({ commit }) {
    commit('clearPositionInfo')
  },
  async clearPositionsList ({ commit }) {
    commit('clearPositionsList')
  }
}

const mutations = {
  getPositionInfo (state, position) {
    state.currentPosition = position
  },
  getPositionsList (state, positions) {
    state.positions = positions
  },
  clearPositionInfo (state) {
    state.currentPosition = null
  },
  clearPositionsList (state) {
    state.positions = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}

*/
